














































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { TokenUser } from '@/TokenUser'
import * as utils from '@/utils';
import AccountComponent from '@/components/AccountComponent.vue';                       // @ is an alias to /src
import * as utils_tracker from '@/utils_tracker';
import * as utils_auth from '@/utils_auth';
import ModalWrapperComponent from '@/components/ModalWrapperComponent.vue';           // @ is an alias to /src

@Component({
  name: 'MyAccount',
  components: { AccountComponent, ModalWrapperComponent }
})

export default class MyAccount extends Vue {
  // prop reactive member variables publically available to the html template

  // public reactive member variables available to the html template
  public lastFetchedURL: string = null;

  // public functions available to the html template
  public get loading(): boolean { return this.$store.state.loading }
  public get user(): TokenUser { return this.$store.getters.userObject }
  public get userId(): string { return this.$store.getters.userId }

  public userChoseRegister(): void {
    utils_auth.setLocationAfterLogin({ name: "home" });
    (this.$refs.RegisterFormModalComponent as ModalWrapperComponent).show('LiveToken Registration', 'sm', null)
  }

  public useChoseLinkTopShotAccount(): void {
    (this.$refs.LinkAccountFormComponent as ModalWrapperComponent).show('Link Top Shot Account', 'md', null)
  }

  // private, non-reactive member variables

  @Watch('$route.path')
  private async pathChanged(): Promise<void> {
    if (this.$store.state.devmode) console.log(`MyAccount.pathChanged() ${this.$route.path}`)
  }

  // private functions not available directly to HTML template
  private async mounted() {
    if (this.$store.state.devmode) console.log(`${this.$options.name} mounted()`)

    utils_tracker.page(this.$options.name)

    if (this.user) utils_tracker.identify(this.user)

    await this.pathChanged()
  }

  private async beforeDestroy() { 
    if (this.$store.state.devmode) console.log(`${this.$options.name} beforeDestroy()`)

  }

}
